import { generate } from '../../../core/js/utils/componentUtils';

import { init as initMobileFacetComponent } from './mobileFacetComponent';
import { init as initMobileFacetTypesComponent } from './mobileFacetTypeComponent';
import { init as initMobileSortComponent } from './mobileSortComponent';
import { init as initMobileFacetCountComponent } from './mobileFacetCountComponent';
import { init as initAppliedFilterCount } from './appliedFilterCountComponent';
import { initializeMobileFacets } from '../actions/facetActions';
import { default as addDropdownSupport } from '@core/js/uiSupport/dropDown';
import { default as addAccordionSupport } from '@core/js/uiSupport/accordion';
import { getDefaultOptions } from '@core/js/utils/a15componentUtils';

function afterConstruction(store) {
    addDropdownSupport(this, this.templateLocation);
    addAccordionSupport(this, this.templateLocation);
    store.dispatch(initializeMobileFacets());
}

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        name: 'mobileFacetsContainer',
        templateLocation: '.dom-facets',
        afterConstruction: afterConstruction,
        children: [
            initMobileFacetTypesComponent,
            initMobileFacetComponent,
            initMobileFacetCountComponent,
            initMobileSortComponent,
            initAppliedFilterCount
        ]
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
